// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBRbaCV0kTrJLE98KAHeL641ObJ2kJlLTg",
  authDomain: "tablerocontrol-d6a80.firebaseapp.com",
  projectId: "tablerocontrol-d6a80",
  storageBucket: "tablerocontrol-d6a80.firebasestorage.app",
  messagingSenderId: "1072678782926",
  appId: "1:1072678782926:web:a830b609d38bdc7b3b4d9f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
export const auth = getAuth(app);